module.exports = __webpack_public_path__ + "static/media/fold-window.edcd835d.png";